<template >
  <b-container fluid>
    <b-row align-h="center" >
      <!-- <b-col cols="12" class="bg-title">
        <h5 style="cursor:pointer; color:white;" class="mt-1 mb-2 d-none d-lg-block">
            <font> Padrones</font>
        </h5>
        <h5 style="cursor:pointer; color:white;" class="mt-1 mb-2 d-block d-lg-none">
          <b-icon @click="isShowSidePanel=!isShowSidePanel; " icon="list" shift-v="-2" font-scale="1.3"/>
            <font> Padrones</font>
        </h5>
      </b-col> -->
      <!-- <Transition>
        <b-col cols="12" sm="10" md="8" lg="4" xl="3" v-if="false" >
          <b-row no-gutters>            
            <b-col  class="sidebar-siprem" cols="12" sm="12" md="12" lg="11" xl="10">
              <b-row>
                <b-col cols="12">
                  <b-button block size="sm" class="btn-cat-sidebar mt-1" @click="opcionFuncionPadron=0; configOptionsSelectTipos(); isShowFormBusqueda=true; hidePanelOpciones();">
                    <b-icon variant="secondary" icon="people-fill"/> Buscar Contribuyente
                  </b-button>
                </b-col>
                <b-col cols="12">
                  <b-button block size="sm" class="btn-cat-sidebar mt-1" @click="opcionFuncionPadron=1; configOptionsSelectTipos(); hidePanelOpciones();">
                    <b-icon variant="secondary" icon="person-plus-fill"/> Agregar Contribuyente
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
            
          </b-row>
        </b-col>
      </Transition> -->


      <b-col cols="11" sm="11" md="11" lg="11" xl="11" class="mt-4">
        <b-alert variant="danger" dismissible @dismissed="cleanMsgError" :show="msgErrorPadrones != ''">
            {{msgErrorPadrones}}
        </b-alert>

        <b-row>
          <b-col>

            <!----------- FORMULARIO DE BUSQUEDA ----------->
            <b-row class="card-form-primary  mt-4" v-if="opcionFuncionPadron==0">

              <b-col cols="12" class="mb-3 mt-3">
                <b-row align-h="between" @click="isShowFormBusqueda=!isShowFormBusqueda" style="cursor:pointer;">
                  <b-col class="mb-2">
                    <h5 style="color: #312bb5"><b-icon icon="people-fill"/> Búsqueda de Contribuyentes</h5>
                    <!-- <h6 style="color: gray; text-transform:capitalize;">{{formasFormModel.inSelectTipoBusqueda.model.toLowerCase()}}</h6> -->
                  </b-col>
                  <b-col class="mt-3" cols="2" md="1" v-if="!isShowFormBusqueda">
                      <b-icon style="color:#312bb5; cursor:pointer;" font-scale="1.3" shift-v="-3" icon="chevron-compact-down" />
                  </b-col>
                  <b-col class="mt-3" cols="2" md="1" v-if="isShowFormBusqueda">
                      <b-icon style="color:#312bb5; cursor:pointer;" font-scale="1.3" shift-v="-3" icon="chevron-compact-up"/>
                  </b-col>
                </b-row>
              </b-col>
              
              <b-col v-if="isShowFormBusqueda">
                <b-row>
                  <b-col cols="12" sm="10" md="6" lg="3" xl="3" >
                    <b-form-group label="Tipo de Padron:">
                      <b-form-select size="sm" :state="!$v.tipoPadron.$invalid" v-model="tipoPadron" :options="catTipoPadrones" @change="configOptionsSelectTipos"></b-form-select>
                      <div class="error" v-if="!$v.tipoPadron.required">Seleccione el tipo de padrón.</div>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="10" md="6" lg="3" xl="3" >
                    <b-form-group label="Buscar por:">
                      <b-form-select size="sm"  v-model="tipoBusqueda" :options="tiposBusqueda" @change="resetBusqueda" ></b-form-select>
                    </b-form-group>
                  </b-col>
                  <!------------ Busqueda por clave--------------->
                  <b-col cols="12" sm="10" md="6" lg="3" xl="3" v-if="tipoBusqueda=='Clave de contribuyente'">
                    <b-form-group label="Clave de contribuyente">
                      <b-form-input size="sm" placeholder="Clave de contribuyente" :state="!$v.claveContribuyente.$invalid" :formatter="formatterUpperCase" v-model="claveContribuyente"></b-form-input>
                      <div class="error" v-if="!$v.claveContribuyente.minLength">La clave debe contener entre 2 y 16 carecteres.</div>
                      <div class="error" v-if="!$v.claveContribuyente.maxLength">La clave debe contener entre 2 y 16 carecteres.</div>
                      <div class="error" v-if="!$v.claveContribuyente.required">Ingrese una clave de contribuyente.</div>
                    </b-form-group>
                  </b-col>
                  <!------------ Busqueda por clave multiple Catastral --------------->
                  <b-col cols="12" class="mb-3" v-if="tipoBusqueda=='Clave Múltiple' && tipoPadron.includes('Catastral')">
                    <b-row>
                      <b-col cols="10" md="6" lg="2">Municipio<b-form-input type="number"  :state="!$v.claveM.municipioIn.$invalid" v-model="claveM.municipioIn" size="sm"></b-form-input></b-col>
                      <b-col cols="10" md="6" lg="2">Zona<b-form-input type="number" :disabled="claveM.zonaTodas" :state="!$v.claveM.zonaIn.$invalid" v-model="claveM.zonaIn" size="sm"></b-form-input><b-form-checkbox v-model="claveM.zonaTodas">Todas</b-form-checkbox></b-col>
                      <b-col cols="10" md="6" lg="2">Manzana<b-form-input type="number" :disabled="claveM.manzanaTodas" :state="!$v.claveM.manzanaIn.$invalid" v-model="claveM.manzanaIn" size="sm"></b-form-input><b-form-checkbox v-model="claveM.manzanaTodas">Todas</b-form-checkbox></b-col>
                      <b-col cols="10" md="6" lg="2">Lote<b-form-input type="number" :disabled="claveM.loteTodos" :state="!$v.claveM.loteIn.$invalid" v-model="claveM.loteIn" size="sm"></b-form-input><b-form-checkbox v-model="claveM.loteTodos">Todos</b-form-checkbox></b-col>
                      <b-col cols="10" md="6" lg="2">Edificio<b-form-input type="text" :disabled="claveM.edificioTodos" :state="!$v.claveM.edificioIn.$invalid" v-model="claveM.edificioIn" size="sm"></b-form-input><b-form-checkbox v-model="claveM.edificioTodos">Todos</b-form-checkbox></b-col>
                      <b-col cols="10" md="6" lg="2">Depto.<b-form-input type="text" :disabled="claveM.deptoTodos" :state="!$v.claveM.deptoIn.$invalid" v-model="claveM.deptoIn" size="sm"></b-form-input><b-form-checkbox v-model="claveM.deptoTodos">Todos</b-form-checkbox></b-col>
                    </b-row>
                  </b-col>
                  <!------------ Busqueda por nombre--------------->
                  <b-col cols="12" sm="10" md="6" lg="3" xl="3" v-if="tipoBusqueda=='Nombre'">
                    <b-form-group label="Nombre">
                      <b-form-input size="sm" placeholder="Nombre de contribuyente" :state="!$v.nombreContribuyente.$invalid" :formatter="formatterUpperCase" v-model="nombreContribuyente"></b-form-input>
                      <div class="error" v-if="!$v.nombreContribuyente.minLength">Ingrese al menos 5 caracteres.</div>
                      <div class="error" v-if="!$v.nombreContribuyente.maxLength">Ingrese un texto entre 5 y 20 caracteres.</div>
                      <div class="error" v-if="!$v.nombreContribuyente.required">Ingrese el nombre de contribuyente.</div>
                    </b-form-group>
                  </b-col>
                  <!------------ Busqueda por ubicacion--------------->
                  <b-col cols="12" sm="10" md="6" lg="3" xl="3" v-if="tipoBusqueda=='Ubicación'">
                    <b-form-group label="Ubicación">
                      <b-form-input size="sm" placeholder="Ubicación del Inmueble" :state="!$v.ubicacionContribuyente.$invalid" :formatter="formatterUpperCase" v-model="ubicacionContribuyente"></b-form-input>
                      <div class="error" v-if="!$v.ubicacionContribuyente.minLength">Ingrese al menos 5 caracteres.</div>
                      <div class="error" v-if="!$v.ubicacionContribuyente.maxLength">Ingrese un texto entre 5 y 10 caracteres.</div>
                      <div class="error" v-if="!$v.ubicacionContribuyente.required">Ingrese la ubicación del inmueble.</div>
                    </b-form-group>
                  </b-col>

                  <!------------ Busqueda por Dato1 Agua--------------->
                  <b-col cols="12" sm="10" md="6" lg="3" xl="3" v-if="tipoBusqueda!='Clave de contribuyente' && tipoBusqueda!='Nombre' && tipoBusqueda!='Ubicación' && tipoPadron.includes('Agua')">
                    <b-form-group label="Dato a buscar">
                      <b-form-input size="sm" placeholder="Ingrese el dato a buscar" :state="!$v.dato1Agua.$invalid" v-model="dato1Agua"></b-form-input>
                      <div class="error" v-if="!$v.dato1Agua.required">Ingrese un dato a buscar.</div>
                    </b-form-group>
                  </b-col>


                  <b-col cols="12" sm="10" md="4" lg="5" xl="2" class="mb-4 pt-4">
                      <b-button block variant="success"  @click="consulta">
                        Buscar <b-icon icon="search" v-if="!isBuscando"/> <b-spinner small v-if="isBuscando"/>
                      </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <!------------------- RESULTADOS DE LA BUSQUEDA --------------------------->
            <b-row  class="mt-4 card-form-blue"  v-if="(opcionFuncionPadron==0 && (contribuyentes.length >0 || this.reporte!=null)) || (contribuyenteActual!=null && contribuyenteActual.tipoContribuyente != undefined && opcionFuncionPadron==0)">
              <b-col cols="12"  class=" mb-3 mt-3" >
                <h5 style="color: #312bb5"><b-icon  shift-v="-1" icon="list-ul"/> Resultado de la Búsqueda</h5>
              </b-col>
              <b-col >
                <b-tabs  v-model="tabIndex" active-nav-item-class="font-weight-bold  text-primary" content-class="mt-3">
                  <!------------- Lista de resultados ------------------------>
                  <b-tab title="Padron " >
                    <div v-if="contribuyentes!=null && contribuyentes.length>=1 && contribuyentes.length <=2000">
                      <b-form-input v-model="filterTablaContribs"  type="search"  placeholder="Buscar" ></b-form-input>
                      <b-table style="max-height:40vh" @row-selected="rowContribSelected"  :filter="filterTablaContribs" sort-icon-left select-mode="single" selectable small responsive striped hover :items="contribuyentes" :fields="fields">
                         <template v-slot:cell(ubicacion)="row">
                            {{row.item.ubicacion.descripcion}}
                        </template>
                      </b-table>
                    </div>  
                   
                    <div v-if="this.reporte!=null && this.reporte!=''">
                      <h6 style="color:red;">Para visualizar el resultado de su búsqueda descargue el excel anexo.</h6>
                      <b-form-textarea v-if="this.reporteMeta!=null && this.reporteMeta.errores!=null" v-model="this.reporteMeta.errores"></b-form-textarea>
                      <h6 style="color:blue" v-if="this.reporteMeta!=null && this.reporteMeta.fechaCorte!=null">Información con fecha de corte al {{this.reporteMeta.fechaCorte}}</h6>
                    </div>  
                    <b-row align="right"  class="mt-5 mb-4" v-if="this.reporte!=null && this.reporte!=''">
                      <b-col>
                        <b-button variant="outline-success" @click="exportResultados">
                          Descargar Excel
                        </b-button>
                      </b-col>
                    </b-row>
                  </b-tab>
                  <!------------- Contribuyente Actual--------------------------->
                  <b-tab  title="Contribuyente Actual" >
                    <panelContribuyenteActual :clave="claveContribuyente" :tipoPadron="tipoPadron" v-if="contribuyenteActual!=null && contribuyenteActual.tipoContribuyente != undefined" />
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
            <!--------------------- FORMULARIO AGREGAR NUEVO CONTRIBUYENTE--------------------------------------->
            <b-row class="card-form-primary  mt-4"  v-if="opcionFuncionPadron==1">
              <b-col cols="12" class="mb-3 mt-3"><h5 style="color:#312bb5"><b-icon icon="person-plus-fill"/> Agregar Contribuyente</h5></b-col>
              <b-col cols="12" lg="3" v-if="catTipoPadronesAgregar.length > 0">
                <b-form-group label="Tipo de Padron:">
                  <b-form-select size="sm" :state="!$v.tipoPadron.$invalid" v-model="tipoPadron" :options="catTipoPadronesAgregar" @change="configOptionsSelectTipos"></b-form-select>
                  <div class="error" v-if="!$v.tipoPadron.required">Seleccione el tipo de padrón.</div>
                </b-form-group>
              </b-col>
              <formContribuyente class="mb-3" v-if="catTipoPadronesAgregar.length > 0" :contribuyenteActual="nuevoContribuyente" :tipoPadron="tipoPadron" :isAgregarContrib="true" :accionPostAgregar="mostrarContribuyenteEncontrado"/>
            </b-row>
            <b-row class="card-form-primary  mt-4"  v-if="opcionFuncionPadron==2">              
              <lecturistaAgua class="mb-3" />
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import { mapState} from 'vuex';
  import panelContribuyenteActual from '@/components/padrones/panelContribuyenteActual.vue';
  import { server,  server2, checkAuth, getGetConfig, getPostConfig, handledError } from '@/axios-tools';
  import axios from 'axios';
  import { minLength, maxLength, required, requiredIf } from 'vuelidate/lib/validators';
  import formContribuyente from '@/components/padrones/formContribuyente.vue';
  import lecturistaAgua from '@/components/padrones/lecturistaAgua.vue';
  import { saveAs } from 'file-saver';

  export default {
    computed: {
      ...mapState({
        contribuyenteActual: state=> state.padrones.contribuyenteActual,
        contribuyentes: state => state.padrones.contribuyentes,
        isBuscando: state => state.padrones.isBuscando,
        catTipoPadrones: state => state.padrones.catalogoPadrones.tipoPadrones,
        catTipoPadronesAgregar: state => state.padrones.catalogoPadrones.tipoPadronesAgregar,
        catTipoBebidas: state => state.padrones.catTipoBebidas,
        catTipoJuegosEspectaculos: state => state.padrones.catTipoJuegosEspectaculos,
        catTipoAnuncios: state => state.padrones.catTipoAnuncios,
        catTipoComercio: state => state.padrones.catTipoComercio,
        catTipoEstacionamiento: state => state.padrones.catTipoEstacionamiento,
        catTipoPanteones: state => state.padrones.catTipoPanteones,
        token: state => state.login.token,
        msgErrorPadrones: state => state.padrones.msgErrorPadrones,
        opcionFuncionPadron: state => state.padrones.opcionFuncionPadron,
      }),
      tiposBusqueda : function(){
        var tipos = [];
        tipos.push('Clave de contribuyente');
        if(this.tipoPadron.includes('1')){
          tipos.push('Clave Múltiple');
        }
        tipos.push('Nombre');
        tipos.push('Ubicación');
        if(this.tipoPadron.includes('3')){
          //igual que en el back
          tipos.push('Tipo de Tarifa');
          tipos.push('Uso del Servicio');
          tipos.push('Tipo de conexión');
          tipos.push('Cuenta con Suministro Agua');
          tipos.push('Tipo de medición agua');
          tipos.push('Cuenta con Drenaje');
          tipos.push('Cuenta con Tratamiento');
          tipos.push('Clave Predial');
          tipos.push('Ruta');
          tipos.push('Grupo');
          tipos.push('Clasificación');
          tipos.push('Clave de Medidor');
          tipos.push('Información Medidor');
        }
        let codeClient=this.$route.params.municipio;
        if(codeClient!='xxx'){
          tipos.push('Obtener todo el padrón');
          tipos.push('Obtener todo el padrón (Rezago)');
        }
        return tipos;
      },
      tipoPadron: {
        get: function() {
          return this.$store.state.padrones.tipoPadron;
        },
        set: function(newValue) {
          this.$store.commit('updateTipoPadron', newValue);
        },
      },
      tipoBusqueda: {
        get: function() {
          return this.$store.state.padrones.tipoBusqueda;
        },
        set: function(newValue) {
          this.$store.commit('updateTipoBusqueda', newValue);
        },
      },
      dato1Agua: {
        get: function() {
          return this.$store.state.padrones.dato1Agua;
        },
        set: function(newValue) {
          this.$store.commit('updateDato1Agua', newValue);
        },
      },
      dato1Manifestacion: {
        get: function() {
          return this.$store.state.padrones.dato1Manifestacion;
        },
        set: function(newValue) {
          this.$store.commit('updateDato1Manifestacion', newValue);
        },
      },
      claveContribuyente: {
        get: function() {
          return this.$store.state.padrones.claveContribuyente;
        },
        set: function(newValue) {
          this.$store.commit('updateClaveContribuyente', newValue);
        },
      },
      nombreContribuyente: {
        get: function() {
          return this.$store.state.padrones.nombreContribuyente;
        },
        set: function(newValue) {
          this.$store.commit('updateNombreContribuyente', newValue);
        },
      },
      ubicacionContribuyente: {
        get: function() {
          return this.$store.state.padrones.ubicacionContribuyente;
        },
        set: function(newValue) {
          this.$store.commit('updateUbicacionContribuyente', newValue);
        },
      },
      isShowFormBusqueda:{
        get: function() {
          return this.$store.state.padrones.isShowFormBusqueda;
        },
        set: function(newValue) {
          this.$store.commit('updateIsShowFormBusqueda', newValue);
        },
      },
      tabIndex:{
        get: function() {
          return this.$store.state.padrones.tabIndex;
        },
        set: function(newValue) {
          this.$store.commit('updateTabIndex', newValue);
        },
      },

    },
    components: {
      panelContribuyenteActual,
      formContribuyente,
      lecturistaAgua
    },
    mounted() {
      
      if(window.matchMedia("(max-width: 768px)").matches){
        this.$store.commit("updateIsShowSideCobro", false);
        
      }
      window.scrollTo(0, 0);
    },
    
    data() {
      return {
        
        fieldsTableContribuyentes:[
                                  {key: 'clave', label: 'Clave'},
                                  {key: 'nombreC', label: 'Nombre'},
                                  {key: 'ubicacion', label: 'Ubicación'},
                                  {key: 'acciones', label: 'Acciones'}
                                ],
        fieldsToExport:{
                    "Clave":"clave",
                    "Clave raiz":"clave2",
                    "Nombre":"nombreC",
                    "Ubicacion":"ubicacion.descripcion",
                    "Domicilio Fiscal":"direccion.descripcion",
                    "CURP":"curp",
                    "RFC":"rfc",
                    "Correo": "correo",
                    "Telefono": "telefono",
                    "Observaciones":"obs",
                    "Notificado":"isNotificado",
                    "No. actos P.A.E.": "noActos",
                },
        nuevoContribuyente:{"clave":"",
                            "clave2":"",
                            "clave3":"",
                            "polPredio":"",
                            "nombre":"",
                            "apellidoP":"",
                            "apellidoC":"",
                            "isBloquearCobro":"false",
                            "ubicacion":{
                              "descripcion":"",
                              "vialidad":"",
                              "noExt":"",
                              "noInt":"",
                              "manzana":"",
                              "lote":"",
                              "colonia":"",
                              "localidad":"",
                              "municipio":"",
                              "estado":"",
                              "codigoPostal":"",
                              "entreCalle":"",
                              "yCalle":"",
                              "denominacion:":"",
                            },
                            "direccion":{
                              "descripcion":"",
                              "vialidad":"",
                              "noExt":"",
                              "noInt":"",
                              "manzana":"",
                              "lote":"",
                              "colonia":"",
                              "localidad":"",
                              "municipio":"",
                              "estado":"",
                              "codigoPostal":"",
                              "entreCalle":"",
                              "yCalle":"",
                              "denominacion:":"",
                            },
                            "curp":"",
                            "rfc":"XAXX010101000",
                            "correo":"",
                            "telefono":"",
                            "obs":"",
                            "isNotificado":"false",
                            "noActos":"0",
                            "tipoPersona":"SIN DATO",
                            "tipoRegimenFiscal":"000 - SIN DATO"
                            },
        isShowAgregarContribuyente:false,
        fields: [
          {
            key: 'clave',
            sortable: true
          },
          {
            key: 'nombreC',
            sortable: true
          },
          {
            key: 'ubicacion',
            sortable: true,
          }
        ],
        filterTablaContribs:null,
        
        claveM:{
          municipioIn:null,
          zonaIn:null,
          manzanaIn:null,
          loteIn:null,
          edificioIn:null,
          deptoIn:null,
          zonaTodas:false,
          manzanaTodas:false,
          loteTodos:false,
          edificioTodos:false,
          deptoTodos:false
        },
       

        reporte:null,
        reporteErrores:''
      }
    },
    methods: {
      resetBusqueda(){
        this.dato1Agua =null;
        this.dato1Manifestacion =null;
        this.claveContribuyente =null;
        this.nombreContribuyente =null;
        this.ubicacionContribuyente = null;
        
        this.claveM.municipioIn=null,
        this.claveM.zonaIn=null,
        this.claveM.manzanaIn=null,
        this.claveM.loteIn=null,
        this.claveM.edificioIn=null,
        this.claveM.deptoIn=null,
        this.claveM.zonaTodas=false,
        this.claveM.manzanaTodas=false,
        this.claveM.loteTodos=false,
        this.claveM.edificioTodos=false,
        this.claveM.deptoTodos=false
        
      },
      formatterUpperCase(value) {
        return value.toUpperCase();
      },
      showAgregarContribuyente(){
        this.isShowAgregarContribuyente=true;
      },
      configOptionsSelectTipos(){
        this.$store.commit("configOptionsSelectTipos", this.tipoPadron.substr(0, 1));
        this.cleanResultsContribuyenteActual();
      },
      rowContribSelected(item){
        this.claveContribuyente = item[0].clave;
        this.consultaContribuyente();

      },
      consulta(){
        if(this.tipoBusqueda=='Clave de contribuyente'){
          this.consultaContribuyente()
        }else if(this.tipoBusqueda=='Obtener todo el padrón'){
          this.consultaPadron(true, false);
        }else if(this.tipoBusqueda=='Obtener todo el padrón (Rezago)'){
          this.consultaPadron(true, true);
        }else{
          this.consultaPadron(false, false);
        }
      },
      consultaContribuyente(){
        if(!this.isBuscando && !this.$v.$invalid && checkAuth(this.$router, this.$store)){
          this.$store.commit("updateIsBuscando", true);
          this.$store.commit("cleanContribuyenteActual", []);
          axios(
            getGetConfig(server.buscarContribuyente, null, this.token, {clave:this.claveContribuyente, tipoPadron:this.tipoPadron.substr(0, 1)})
            ).then(res => {
              this.$store.commit("updateContribuyenteActual", res.data);
              this.mostrarContribuyenteEncontrado(res.data);
              this.$store.commit("updateIsBuscando", false);
            }).catch(err => {
                this.$store.commit("updateIsBuscando", false);
                handledError(err, server.buscarContribuyente, this.$router, this.$store);
            })
        }
      },
      mostrarContribuyenteEncontrado(contribuyente){
        this.isShowFormBusqueda=false;
        this.tabIndex=1;
                
        if(contribuyente.tipoContribuyente == "2"){
          this.$store.commit("updateCatOptionsTipoFiscal", this.catTipoBebidas);
        }else if(contribuyente.tipoContribuyente == "4"){
          this.$store.commit("updateCatOptionsTipoFiscal", this.catTipoJuegosEspectaculos);
        }else if(contribuyente.tipoContribuyente == "5"){
          this.$store.commit("updateCatOptionsTipoFiscal", this.catTipoAnuncios);
        }else if(contribuyente.tipoContribuyente == "6"){
          this.$store.commit("updateCatOptionsTipoFiscal", this.catTipoComercio);
        }else if(contribuyente.tipoContribuyente == "7"){
          this.$store.commit("updateCatOptionsTipoFiscal", this.catTipoEstacionamiento);
        }else if(contribuyente.tipoContribuyente == "8"){
          this.$store.commit("updateCatOptionsTipoFiscal", this.catTipoPanteones);
        }
      },
      consultaPadron(buscarTodo, conRezago){
        if(!this.isBuscando && !this.$v.$invalid && checkAuth(this.$router, this.$store)){
          this.$store.commit("updateIsBuscando", true);
          this.$store.commit("cleanContribuyenteActual");
          /*
          var opciones ={
            tipoPadron:this.tipoPadron,
            claveContribuyente:this.claveContribuyente,


            tipoBusqueda:this.tipoBusqueda,
            
            nombreContribuyente:this.nombreContribuyente,
            municipioIn:this.claveM.municipioIn,
            zonaIn:this.claveM.zonaIn,
            manzanaIn:this.claveM.manzanaIn,
            loteIn:this.claveM.loteIn,
            edificioIn:this.claveM.edificioIn,
            deptoIn: this.claveM.deptoIn,
            municipioTodos:buscarTodo?true:false,
            zonaTodas:buscarTodo?true:this.claveM.zonaTodas,
            manzanaTodas:buscarTodo?true:this.claveM.manzanaTodas,
            loteTodos:buscarTodo?true:this.claveM.loteTodos,
            edificioTodos:buscarTodo?true:this.claveM.edificioTodos,
            deptoTodos:buscarTodo?true:this.claveM.deptoTodos,
            ubicacion:this.ubicacionContribuyente,
            dato1Agua:this.dato1Agua
          }*/
          var opciones = this.genOpcionesCobro(buscarTodo, conRezago);
          axios(
            getPostConfig(buscarTodo? server2.buscarContribuyentes : server.buscarContribuyentes, opciones, this.token, {})
            ).then(res => {
              this.isShowFormBusqueda=false;
              this.$store.commit('updateContribuyentes', res.data.contribuyentes);
              this.$store.commit("updateIsBuscando", false);
              this.reporte= res.data.reporte.excelXls;
              this.reporteMeta = res.data.reporte.meta;
              this.tabIndex=0;
            }).catch(err => {
                this.$store.commit("updateIsBuscando", false);
                handledError(err, server.buscarContribuyente, this.$router, this.$store);
            })
        }
      },
      genOpcionesCobro(buscarTodo, conRezago){

          const opcionesBusqueda= {
            tipoPdron:parseInt(this.tipoPadron.substring(0,1)),          
            mpioEdited:(buscarTodo?false:true),
            zonaEdited:(buscarTodo?false:!this.claveM.zonaTodas),
            mzanaEdited:(buscarTodo?false:!this.claveM.manzanaTodas),
            loteEdited:(buscarTodo?false:!this.claveM.loteTodos),
            edifEdited:(buscarTodo?false:!this.claveM.edificioTodos),
            deptoEdited:(buscarTodo?false:!this.claveM.deptoTodos),
            serieEdited:(buscarTodo?false:true),
            folioEdited:(buscarTodo?false:true),
            cuentaEdited:(buscarTodo?false:true),
            siAdeudo:conRezago,
            siAños:false,
            incluirRezagados:conRezago,
            incluirCorrientes:conRezago,
            numActos:null,
            tipoLiqidacion :0,
            mesLiq:12,
            añoLiq:2026,
            siDetalles:true,          
            nombreContrib:this.nombreContribuyente,
            ubicacion:this.ubicacionContribuyente,
            tipoPersona:null,
            dato1Agua:this.dato1Agua,
            columna1Agua:this.tipoBusqueda,
            dato1Manifestacion:this.dato1Manifestacion,
            columna1Manifestacion:'',
            incluirSubsidios:false,
            incluirPAE:false,
            incluirBaseFiscal:buscarTodo 
          };

          

        const opR={
          opciones:opcionesBusqueda,
          municipioIn:this.claveM.municipioIn,
          zonaIn:this.claveM.zonaIn,
          manzanaIn:this.claveM.manzanaIn,
          loteIn:this.claveM.loteIn,
          edificioIn:this.claveM.edificioIn,
          deptoIn:this.claveM.deptoIn
        }
        return opR;
          
      },
      cleanMsgError(){
        /* Se manda cadena vacia a MsgErrorContribuyente en el store, ya que el <b-alert> para mostrar errores solo se muestra si este es diferente de cadena vacia */
        this.$store.commit("updateMsgErrorPadrones", '');
      },
      cleanResultsContribuyenteActual (){
        this.$store.commit("cleanContribuyenteActual");
        this.$store.commit('updateContribuyentes', []);
      },
      exportResultados(){
        var byteString = atob(this.reporte);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
          
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        var fxport = function(nombre){
            saveAs(new Blob([ab],{type:"application/octet-stream"}), nombre+'.xlsx');
        };

        setTimeout(
            fxport.bind(null, 'padron_contribuyentes_'+(new Date().getMilliseconds()))
        , 1000);
        
      },
    },
    validations:{
      tipoPadron:{
                  required
                },
      claveContribuyente:{
                 required:requiredIf(function(){return this.tipoBusqueda=='Clave de contribuyente'}),
                  minLength: minLength(1),
                  maxLength: maxLength(25)
      },
      nombreContribuyente:{
                  required:requiredIf(function(){return this.tipoBusqueda=='Nombre'}),
                  minLength: minLength(5),
                  maxLength: maxLength(20)
      },
      ubicacionContribuyente:{
                  required:requiredIf(function(){return this.tipoBusqueda=='Ubicación'}),
                  minLength: minLength(5),
                  maxLength: maxLength(20)
      },
      dato1Agua:{
                //igual que en el back
                required:requiredIf(function(){
                  return(
                    this.tipoBusqueda=='Tipo de Tarifa' ||
                    this.tipoBusqueda=='Uso del Servicio' ||
                    this.tipoBusqueda=='Tipo de conexión' ||
                    this.tipoBusqueda=='Cuenta con Suministro Agua' ||
                    this.tipoBusqueda=='Tipo de medición agua' ||
                    this.tipoBusqueda=='Cuenta con Drenaje' ||
                    this.tipoBusqueda=='Cuenta con Tratamiento' ||
                    this.tipoBusqueda=='Clave Predial' ||
                    this.tipoBusqueda=='Ruta' ||
                    this.tipoBusqueda=='Grupo' ||
                    this.tipoBusqueda=='Clasificación' ||
                    this.tipoBusqueda=='Clave de Medidor' ||
                    this.tipoBusqueda=='Información Medidor');
                  
                  }),
      },
      claveM:{
        municipioIn:{
          required:requiredIf(function(){return this.tipoBusqueda=='Clave Múltiple'})
        },
        zonaIn:{
          required:requiredIf(function(){return this.tipoBusqueda=='Clave Múltiple'&&!this.claveM.zonaTodas})
        },
        manzanaIn:{
          required:requiredIf(function(){return this.tipoBusqueda=='Clave Múltiple'&&!this.claveM.manzanaTodas})
        },
        loteIn:{
          required:requiredIf(function(){return this.tipoBusqueda=='Clave Múltiple'&&!this.claveM.loteTodos})
        },
        edificioIn:{
          required:requiredIf(function(){return this.tipoBusqueda=='Clave Múltiple'&&!this.claveM.edificioTodos})
        },
        deptoIn:{
          required:requiredIf(function(){return this.tipoBusqueda=='Clave Múltiple'&&!this.claveM.deptoTodos})
        },
        
      }
    }
  }
</script>
<style>
.button-margin {margin: 30px 0%;}
.row-margin {margin: 5px auto;}
.button-add-contrib{
  margin-bottom:10px;
}
</style>